<!--
 * @FileDescription: 新增零件或总成件的模板（注释描述）
 * @Author: xy（作者）
 * @Date: 2020-04-13（时间）
 * @LastEditors: xy（最后更新人）
 * @LastEditTime: 2020-04-13（最后更新时间）
 -->
<template>
  <div>
    <a-modal class="management" :title="title" :maskClosable="false" :footer="null" v-model="isShowModel"
      @cancel="onCancel">
      <div class="man-top-bac"></div>
      <a-tabs class="manage-tab" :activeKey="defaultTab" @change="changeTab">
        <a-tab-pane key="1" tab="基本信息">
          <a-form :form="form" class="manage-model">
            <a-col :md="10" :sm="12">
              <a-form-item label="商品名称" class="form-manage">
                <a-input placeholder="请输入商品名称" allow-clear ref="inputName"
                  v-decorator="['name',{rules: [{ required: true, message: '请输入商品名称!' }],},]" @change="onInputName()" />
              </a-form-item>
            </a-col>
            <a-col :md="10" :sm="12" v-if="!isEmpty(modelData.id)">
              <a-form-item label="商品编号" class="form-manage">
                <a-input placeholder="请输入商品编号" allow-clear disabled
                  v-decorator="['code',{rules: [{ required: true, message: '请输入商品编号!' }],},]" />
              </a-form-item>
            </a-col>
            <a-col :md="10" :sm="12">
              <a-form-item label="所属分类">
                <a-input placeholder="请选择商品分类" allow-clear disabled
                  v-decorator="['categoryName',{rules: [{ required: true, message: '请选择商品分类!' }],},]" />
              </a-form-item>
            </a-col>
            <a-col :md="10" :sm="12">
              <a-form-item label="商品型号">
                <a-input placeholder="请输入商品型号" disabled allow-clear
                  v-decorator="['model',{rules: [{ required: false}],},]" />
              </a-form-item>
            </a-col>
            <a-col :md="10" :sm="12">
              <a-form-item label="商品规格">
                <a-input placeholder="请输入商品规格" allow-clear disabled
                  v-decorator="['specification',{rules: [{ required: false}],},]" />
              </a-form-item>
            </a-col>
            <a-col :md="10" :sm="12">
              <a-form-item label="商品品牌">
                <div class="brand-select">
                  <div class="brand-select-input">
                    <a-input placeholder="请选择或输入商品品牌" disabled
                      v-decorator="['brandName',{ rules: [{ required: false}] },]"></a-input>
                    <a-icon slot="suffixIcon" type="caret-down" style="color: #555555" />
                  </div>
                </div>
              </a-form-item>
            </a-col>
            <a-col :md="10" :sm="12">
              <a-form-item label="适配机型">
                <div class="manage-setting">
                  <a-input placeholder="请选择适配机型" allow-clear disabled
                    v-decorator="['adaptiveModelName',{rules: [{ required: false}],},]" />
                </div>
              </a-form-item>
            </a-col>
            <a-col :md="10" :sm="12">
              <a-form-item label="商品重量" class="form-manage1">
                <a-input placeholder="请输入商品净重" disabled allow-clear type="number" v-decorator="['weight']" />
              </a-form-item>
            </a-col>
            <a-col :md="10" :sm="12">
              <a-form-item label="商品产地">
                <a-input placeholder="请输入商品产地" disabled allow-clear v-decorator="['place']" />
              </a-form-item>
            </a-col>
            <a-col :md="10" :sm="12">
              <a-form-item label="商品拼音码">
                <a-input placeholder="请输入商品名称首写字母拼音码，用于搜索商品" allow-clear v-decorator="['pinyinCode']" />
              </a-form-item>
            </a-col>
            <a-col :md="10" :sm="12">
              <a-form-item label="主机原厂编号">
                <a-input placeholder="请输入主机原厂编号" allow-clear disabled v-decorator="['hostOriginalCode']" />
              </a-form-item>
            </a-col>
            <a-col :md="10" :sm="12">
              <a-form-item label="厂家编号">
                <a-input placeholder="请输入厂家编号" allow-clear disabled v-decorator="['factoryCode']" />
              </a-form-item>
            </a-col>
            <a-col :md="10" :sm="12">
              <a-form-item label="是否上架">
                <a-radio-group v-decorator="['soldOutFlag']">
                  <a-radio :value="1">
                    否
                  </a-radio>
                  <a-radio :value="0">
                    是
                  </a-radio>
                </a-radio-group>
              </a-form-item>
            </a-col>
            <a-col :md="10" :sm="12">
              <a-form-item label="是否为升级礼包商品">
                <a-radio-group v-decorator="['upgradeGiftFlag']">
                  <a-radio :value="0">
                    否
                  </a-radio>
                  <a-radio :value="1">
                    是
                  </a-radio>
                </a-radio-group>
              </a-form-item>
            </a-col>
            <a-col :md="10" :sm="12">
              <a-form-item label="是否推荐">
                <a-radio-group v-decorator="['recommendFlag']">
                  <a-radio :value="0">
                    否
                  </a-radio>
                  <a-radio :value="1">
                    是
                  </a-radio>
                </a-radio-group>
              </a-form-item>
            </a-col>
            <a-col :md="10" :sm="12">
              <a-form-item label="是否是拼团商品">
                <a-radio-group v-model="modelData.groupBuyingFlag" @change="changeBuyingFlag">
                  <a-radio :value="0">
                    否
                  </a-radio>
                  <a-radio :value="1">
                    是
                  </a-radio>
                </a-radio-group>
              </a-form-item>
            </a-col>
          </a-form>
        </a-tab-pane>
        <a-tab-pane key="2" tab="售价信息">
          <a-table :columns="columns" :dataSource="dataSourcePrice" v-clickoutside:[classList]="closeIconBlock" bordered
            rowKey="id">
            <template slot="data1" slot-scope="text, record">
              <span v-show="!record.isCheck1" @click="companyClick(1,record)"
                class="table-span">{{record.unitName}}</span>
              <a-input v-if="record.isCheck1" v-model="record.unitName" ref="inputs"></a-input>
            </template>
            <template slot="data3" slot-scope="text, record">
              <span v-show="!record.isCheck2" @click="companyClick(2,record)"
                class="table-span">{{record.originalPrice}}</span>
              <a-input-number v-if="record.isCheck2" v-focus :min="0" :step="0.01" :value="record.originalPrice"
                @change="e=>onChangeNumber(e,record,1)" />
            </template>
            <template slot="data4" slot-scope="text, record">
              <span v-show="!record.isCheck3" @click="companyClick(3,record)"
                class="table-span">{{record.retailPrice}}</span>
              <a-input-number v-if="record.isCheck3" v-focus :min="0" :step="0.01" :value="record.retailPrice"
                @change="e=>onChangeNumber(e,record,2)" />
            </template>
            <template slot="groupPurchasePrice" slot-scope="text, record">
              <span v-show="!record.isCheck5" @click="companyClick(5,record)"
                class="table-span">{{record.groupPurchasePrice}}</span>
              <a-input-number v-if="record.isCheck5" v-focus :min="0" :step="0.01" :value="record.groupPurchasePrice"
                @change="e=>onChangeNumber(e,record,5)" />
            </template>
            <template slot="data5" slot-scope="text, record">
              <span v-show="!record.isCheck4" @click="companyClick(4,record)"
                class="table-span">{{record.storeCostPrice}}</span>
              <a-input-number v-if="record.isCheck4" v-focus :min="0" :step="0.01" :value="record.storeCostPrice"
                @change="e=>onChangeNumber(e,record,3)" />
            </template>
          </a-table>
        </a-tab-pane>
        <a-tab-pane key="3" tab="商品图片">
          <a-row>
            <div class="manage-upload-title1">上传轮播图(同缩略图)</div>
            <div class="manage-upload-title">注：单张图片大小不能超过1M，最多可上传5张，仅支持jpg、jpeg、png格式</div>
          </a-row>
          <multiflecloud ref="multiflecloud" @onChangeImg="onChangeImg" @onChangeImgmain="onChangeImgmain">
          </multiflecloud>
        </a-tab-pane>
        <a-tab-pane key="4" tab="商品详情">
          <template v-if="defaultTab == 4">
            <a-row>
              <div class="manage-upload-title1">上传商品详情图</div>
              <div class="manage-upload-title">注：单张图片大小不能超过1M,仅支持jpg、jpeg、png格式</div>
            </a-row>
            <uploadcloud ref="uploadcloud" @onChangeImg="onChangeImgshop"></uploadcloud>
          </template>
        </a-tab-pane>
      </a-tabs>
      <div class="manage-btn">
        <a-button class="manage-btn1" @click="onCancel">取消</a-button>
        <a-button type="primary" class="btn-save" @click="onSave()">保存</a-button>
      </div>
      <div class="line"></div>
    </a-modal>
  </div>
</template>
<script>
//商品详情和商品编辑没测
import multiflecloud from "@/components/upload/multiflecloud";
import uploadcloud from "@/components/upload/uploadcloud";
import {
  productsave,
  priceList,
  modelSave,
  productupdatecloud,
  classificationList,
  brandList,
  modelUpdate,
  productIdcloud,
} from "@/utils/api";
import { mixins } from "@/mixins/mixins";
// import ATableColumn from "ant-design-vue/es/table/Column";
// import locationSelect from '@/components/locationSelect'
import pick from "lodash.pick";
import vPinyin from "@/common/vue-py";
export default {
  mixins: [mixins],
  props: {},
  data() {
    return {
      newIndex: 1,
      defaultTab: "1",
      title: "新增零件",
      form: this.$form.createForm(this),
      isShowModel1: false,
      isShowModel: false,
      title1: "新增适配机型",
      form1: this.$form.createForm(this),
      value: 1,
      companyCheck: false,
      inputbrand: "",
      isbrand: false,
      columns: [],
      columnsNot: [
        {
          title: "选项",
          dataIndex: "data",
          key: "data",
          width: 90,
          align: "center",
        },
        {
          title: "单位名称",
          key: "name",
          align: "center",
          dataIndex: "name",
          width: 90,
          scopedSlots: { customRender: "data1" },
        },
        {
          title: "原价",
          key: "retailPrice",
          align: "right",
          dataIndex: "retailPrice",
          width: 120,
          scopedSlots: { customRender: "data3" },
        },
        {
          title: "售价",
          key: "presellPrice1",
          align: "right",
          dataIndex: "presellPrice1",
          width: 120,
          scopedSlots: { customRender: "data4" },
        },
        {
          title: "门店成本价",
          key: "storeCostPrice",
          align: "right",
          dataIndex: "storeCostPrice",
          width: 120,
          scopedSlots: { customRender: "data5" },
        },
      ],
      columnsYes: [
        {
          title: "选项",
          dataIndex: "data",
          key: "data",
          width: 90,
          align: "center",
        },
        {
          title: "单位名称",
          key: "name",
          align: "center",
          dataIndex: "name",
          width: 90,
          scopedSlots: { customRender: "data1" },
        },
        {
          title: "原价",
          key: "retailPrice",
          align: "right",
          dataIndex: "retailPrice",
          width: 120,
          scopedSlots: { customRender: "data3" },
        },
        {
          title: "售价",
          key: "presellPrice1",
          align: "right",
          dataIndex: "presellPrice1",
          width: 120,
          scopedSlots: { customRender: "data4" },
        },
        {
          title: "拼团价",
          key: "groupPurchasePrice",
          align: "right",
          dataIndex: "groupPurchasePrice",
          width: 120,
          scopedSlots: { customRender: "groupPurchasePrice" },
        },
        {
          title: "门店成本价",
          key: "storeCostPrice",
          align: "right",
          dataIndex: "storeCostPrice",
          width: 120,
          scopedSlots: { customRender: "data5" },
        },
      ],
      dataSourcePrice: [
        {
          data: "基本单位",
          unitName: "",
          originalPrice: "",
          retailPrice: "",
          storeCostPrice: "",
          groupPurchasePrice: "",
          isCheck1: false,
          isCheck2: false,
          isCheck3: false,
          isCheck4: false,
          isCheck5: false,
        },
      ],
      timeoutID: null,
      spareIndex: "",
      classList: [],
      introduction: "",
      classObj: [],
      imgurls: [],
      imgurlmain: {},
      brandListSelect: [],
      priceList: [],
      modelData: {},
      model1: {},
      modelstr: "",
      paginationmodel: {
        current: 1,
        total: 0,
        pages: 0,
      },
      goodshop: [],
    };
  },
  watch: {},
  mounted() {},
  created() {},
  components: {
    // ATableColumn,
    multiflecloud,
    // locationSelect,
    uploadcloud,
  },
  methods: {
    closeIconBlock() {
      this.dataSourcePrice.forEach((item) => {
        item.isCheck1 = false;
        item.isCheck2 = false;
        item.isCheck3 = false;
        item.isCheck4 = false;
        item.isCheck5 = false;
      });
    },
    onInputName() {
      setTimeout(() => {
        let input = this.$refs.inputName.value;
        this.$nextTick(() => {
          this.form.setFieldsValue({
            pinyinCode: vPinyin.chineseToPinYin(input),
          });
        });
      }, 200);
    },
    changeBuyingFlag(e) {
      if (e.target.value == 0) {
        this.columns = this.columnsNot;
      } else {
        this.columns = this.columnsYes;
      }
      this.modelData.groupBuyingFlag = e.target.value;
      console.log(e.target.value);
    },
    onBlur(record, index) {
      if (index == 1) {
        record.productName = record.productName1;
        record.isCheck1 = false;
      } else {
        record.code = record.code1;
        record.isCheck3 = false;
      }
    },
    /**
     * @description: 此为方法注释（方法描述）
     */
    onCancel() {
      this.isShowModel = false;
      this.defaultTab = "1";
    },
    onOpen(record, index, index1) {
      this.defaultTab = "1";
      this.modelData = {};
      this.columns = this.columnsNot;

      if (index == 3) {
        this.title = "编辑商品";
        let data = {
          id: record.id,
          companyStoreId: this.$store.state.shopId,
        };
        data = this.$qs.stringify(data);
        this.imgurls = [];
        this.imgurlmain = {};
        this.goodshop = [];
        productIdcloud(data, {}).then((res) => {
          if (res.success) {
            this.modelData = {};
            this.modelData = res.result;
            this.modelData.recommendFlag = parseInt(res.result.recommendFlag);
            this.modelData.groupBuyingFlag = parseInt(
              res.result.groupBuyingFlag ? res.result.groupBuyingFlag : 0
            );
            if (this.modelData.groupBuyingFlag == 0) {
              this.columns = this.columnsNot;
            } else {
              this.columns = this.columnsYes;
            }
            this.modelData.soldOutFlag = parseInt(res.result.soldOutFlag);
            this.modelData.upgradeGiftFlag = parseInt(
              res.result.upgradeGiftFlag
            );
            this.form = this.$form.createForm(this);
            this.isShowModel = true;
            this.$nextTick(() => {
              this.form.setFieldsValue(
                pick(
                  this.modelData,
                  "recommendFlag",
                  "groupBuyingFlag",
                  "code",
                  "count",
                  "model",
                  "specification",
                  "unit",
                  "assemblyFlag",
                  "id",
                  "categoryId",
                  "brandId",
                  "adaptiveModelIdStr",
                  "weight",
                  "place",
                  "pinyinCode",
                  "hostOriginalCode",
                  "factoryCode",
                  "name",
                  "brandName",
                  "categoryName",
                  "upgradeGiftFlag",
                  "soldOutFlag",
                  "adaptiveModelName"
                )
              );
              this.modelData.goodsInfoResourceUrlList.forEach((item) => {
                if (item.resourceTag == 1) {
                  if (item.primaryImgFlag == 1) {
                    this.imgurlmain = item;
                  } else {
                    this.imgurls.push(item);
                  }
                } else {
                  this.goodshop.push(item);
                }
              });
              this.dataSourcePrice[0].unitName = res.result.unitName;
              this.dataSourcePrice[0].originalPrice = res.result.originalPrice;
              this.dataSourcePrice[0].retailPrice = res.result.retailPrice;
              this.dataSourcePrice[0].storeCostPrice =
                res.result.storeCostPrice;
              this.dataSourcePrice[0].groupPurchasePrice =
                res.result.groupPurchasePrice;
            });
          }
        });
      }
    },
    /**
     * @description: 切换面板（方法描述）
     */
    changeTab(key) {
      this.defaultTab = key;
      if (this.defaultTab == 3) {
        this.$nextTick(() => {
          this.$refs.multiflecloud.onOpen(this.imgurls, this.imgurlmain);
        });
      } else if (this.defaultTab == 4) {
        this.$nextTick(() => {
          this.$refs.uploadcloud.onOpen(this.goodshop);
        });
      }
    },
    /**
     * @description: 售价信息输入框出现（方法描述）
     */
    companyClick(index, record) {
      this.closeIconBlock();
      if (index == 1) {
        record.isCheck1 = true;
      } else if (index == 2) {
        record.isCheck2 = true;
      } else if (index == 3) {
        record.isCheck3 = true;
      } else if (index == 4) {
        record.isCheck4 = true;
      } else if (index == 5) {
        record.isCheck5 = true;
      }
      if (index == 2 || index == 1) {
        this.$nextTick(() => {
          this.$refs.inputs.focus();
        });
      }
    },
    /**
     * @description: 售价信息输入框的值（方法描述）
     */
    onChangeNumber(value, record, index) {
      if (index == 1) {
        record.originalPrice = value;
      } else if (index == 2) {
        record.retailPrice = value;
      } else if (index == 3) {
        record.storeCostPrice = value;
      } else if (index == 5) {
        record.groupPurchasePrice = value;
      }
    },
    /**
     * @description: 图片（方法描述）
     */
    onChangeImg(imgUrl) {
      // console.log(imgUrl)
      this.imgurls = imgUrl;
    },
    onChangeImgmain(imgUrl) {
      this.imgurlmain = imgUrl;
      // console.log(this.imgurlmain)
    },

    onChangeImgshop(imgUrl) {
      // console.log(imgUrl)
      this.goodshop = imgUrl;
    },
    /**
     * @description: 保存的两种转态（方法描述）
     */
    onSave(index) {
      this.form.validateFields((err, values) => {
        if (!err) {
          let model = {};
          values.companyStoreId = this.$store.state.shopId;
          values.companyId = this.$store.state.companyId;
          model = values;
          model.id = this.modelData.id;
          model.goodsInfoResourceUrlList = [];
          if (
            (!this.isEmpty(this.dataSourcePrice[0].retailPrice) ||
              !this.isEmpty(this.dataSourcePrice[0].originalPrice)) &&
            this.isEmpty(this.dataSourcePrice[0].unitName)
          ) {
            this.$message.warn("需要填单位名称哦~");
            return;
          }
          if (this.isEmpty(this.dataSourcePrice[0].unitName)) {
            return;
          }
          console.log(this.modelData.groupBuyingFlag)
          console.log(this.isEmpty(this.dataSourcePrice[0].groupPurchasePrice))
          if (this.modelData.groupBuyingFlag == 1) {
            if (this.isEmpty(this.dataSourcePrice[0].groupPurchasePrice)) {
              this.$message.warn("需要填拼团价格哦~");
              return;
            }
          }
          model.unitName = this.dataSourcePrice[0].unitName;
          model.retailPrice = this.dataSourcePrice[0].retailPrice;
          model.originalPrice = this.dataSourcePrice[0].originalPrice;
          model.storeCostPrice = this.dataSourcePrice[0].storeCostPrice;
          model.groupPurchasePrice = this.dataSourcePrice[0].groupPurchasePrice;
          model.groupBuyingFlag = this.modelData.groupBuyingFlag;
          if (!this.isEmpty(this.imgurlmain.resourceId)) {
            model.goodsInfoResourceUrlList.push({
              resourceId: this.imgurlmain.resourceId,
              resourceTag: 1,
              primaryImgFlag: 1,
              resourceUrl: this.imgurlmain.resourceUrl,
              sort: 1,
            });
          }
          if (this.imgurls.length > 0) {
            this.imgurls.forEach((item, index) => {
              if (this.isEmpty(item.sort)) {
                model.goodsInfoResourceUrlList.push({
                  resourceId: item.resourceId,
                  resourceTag: 1,
                  resourceUrl: item.resourceUrl,
                  sort: index + 2,
                });
              } else {
                model.goodsInfoResourceUrlList.push({
                  resourceId: item.resourceId,
                  resourceTag: 1,
                  resourceUrl: item.resourceUrl,
                  sort: index + 2,
                  id: item.id,
                });
              }
            });
          }
          if (this.goodshop.length > 0) {
            this.goodshop.forEach((item, index) => {
              if (this.isEmpty(item.sort)) {
                model.goodsInfoResourceUrlList.push({
                  resourceId: item.resourceId,
                  resourceTag: 2,
                  resourceUrl: item.resource_url,
                  sort: index + 1,
                });
              } else {
                model.goodsInfoResourceUrlList.push({
                  resourceId: item.resourceId,
                  resourceTag: 2,
                  resourceUrl: item.resource_url,
                  sort: index + 1,
                  id: item.id,
                });
              }
            });
          }
          productupdatecloud(model, {
            "Content-Type": "application/json",
          }).then((res) => {
            if (res.success) {
              this.isShowModel = false;
              this.$emit("pageListTab", 1);
              this.$message.success(res.logMessage);
            } else {
              this.$message.warn(res.logMessage);
            }
          });
        } else {
          this.$message.warn("您还有必填数据没有填写哦~");
        }
      });
    },
  },
};
</script>
<style lang="scss">
.ant-cascader-menu {
  width: 143px;
}
.ant-select-tree
  li
  .ant-select-tree-node-content-wrapper.ant-select-tree-node-selected {
  background-color: #f2f7ff !important;
}
.ant-modal {
  padding-bottom: 0;
  .ant-modal-content {
    width: 100%;
    height: 100%;
  }
}
.manage-model1 {
  width: 660px !important;
  height: 340px !important;
}
.manage-tab {
  padding: 0 38px 0 66px;
  box-shadow: 0px 0px 6px 0px rgba(85, 85, 85, 0.12);
  .ant-tabs-nav .ant-tabs-tab {
    color: #888888;
    font-size: 16px;
    margin: 0 10px 0 0;
    padding: 14px 16px;
  }
  .ant-tabs-nav .ant-tabs-tab-active {
    color: var(--co);
    font-size: 20px;
    font-weight: 700;
  }
  .table-span {
    width: calc(100% - 30px);
    padding-left: 5px;
    height: 30px;
    line-height: 30px;
    display: inline-block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .manage-setting {
    .ant-select-selection--multiple .ant-select-selection__rendered {
      height: 34px;
      overflow: auto;
    }
  }
  .brand-select {
    width: 425px;
    height: 36px;
    position: relative;
    .brand-select-input {
      width: 100%;
      height: 100%;
      position: relative;
      input {
        padding-right: 30px;
      }
      .anticon-caret-down {
        position: absolute;
        top: 50%;
        right: 10px;
        transform: translateY(-40%);
      }
    }
    .brand-select-content {
      position: absolute;
      top: 40px;
      left: 0;
      background: #ffffff;
      width: 425px;
      max-height: 160px;
      min-height: 50px;
      overflow: auto;
      z-index: 10;
      padding: 10px 0 10px 0;
      border-radius: 2px;
      box-shadow: 0 3px 6px -4px rgba(0, 0, 0, 0.12),
        0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 9px 28px 8px rgba(0, 0, 0, 0.05);
      .brand-select-item {
        cursor: pointer;
        height: 30px;
        text-align: center;
        line-height: 30px;
      }
      .brand-select-item:hover {
        background: #f5f6f5;
      }
    }
  }
}
.man-top-bac {
  width: 100%;
  height: 10px;
  position: absolute;
  top: 55px;
  left: 0;
  background-color: #fff;
  z-index: 100;
}
.manage-model {
  input {
    box-shadow: inset 0 0 0 1000px #f7f7f7 !important;
  }
  .ant-input {
    background-color: #fafafa !important;
  }
  .ant-col-md-10 {
    margin-right: 80px;
    height: 103px;
    &:nth-child(2n) {
      margin-right: 0;
    }
  }
  .form-manage {
    .ant-form-item-label > label::after {
      /*content:'（输入名称关键词可以选择商品类型，快速录入）'!important;*/
      color: #888888;
      font-size: 14px;
    }
  }
  .form-manage1 {
    .ant-form-item-label > label::after {
      content: "(单位KG)" !important;
      color: #888888;
      font-size: 14px;
    }
  }
  .ant-form-item-control-wrapper {
    height: 40px;
  }
  .tree-manage {
    height: 40px;
    .ant-select-selection {
      background-color: #fafafa;
    }
  }
}
.management {
  width: 1126px !important;
  height: 980px !important;
  .spare-table {
    .ant-table-body {
      overflow-x: hidden;
    }
  }
  .ant-modal-body {
    padding: 0;
  }
  .ant-tabs-tabpane {
    min-height: 740px;
    overflow-y: auto;
  }
  .ant-pagination {
    display: none;
  }
  .manage-btn {
    height: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #fcfcfc;
    border-radius: 10px;
    .manage-btn1 {
      margin-right: 24px;
    }
  }
  .line {
    position: absolute;
    top: 74px;
    left: 0;
    height: 10px;
    width: 100%;
    background-color: #fff;
  }
  .ant-table-tbody > tr > td {
    padding: 10px 0;
  }
  .ant-input-number {
    width: 100%;
    height: 36px;
    line-height: 36px;
    background-color: #fafafa;
  }
  .ant-input-number-input {
    padding: 0 25px 0 0;
    text-align: right;
  }
  .manage-setting {
    display: flex;
    align-items: center;
    .setting-img {
      cursor: pointer;
      font-size: 16px;
      margin-left: 10px;
    }
  }
}
.manage-upload-title1 {
  padding-top: 30px;
  color: #333;
  font-size: 16px;
  padding-bottom: 15px;
}
.manage-upload-title {
  padding-bottom: 30px;
  color: var(--co);
}
.table-img {
  width: 40px;
  height: 40px;
}
.location-table {
  width: 525px;
  .ant-table-tbody > tr {
    height: 60px;
  }
  .ant-table-tbody > tr > td:first-child {
    padding: 10px 16px;
  }
  .table-name {
    cursor: pointer;
    display: inline-block;
    width: 100%;
    height: 36px;
    padding-left: 16px;
    line-height: 36px;
  }
}
.manage-company-check {
  padding-top: 10px;
  padding-bottom: 15px;
  display: flex;
  color: #888888;
  img {
    width: 16px;
    margin-left: 20px;
    margin-bottom: 3px;
  }
}
</style>
